import script from "./IspContent.vue?vue&type=script&setup=true&lang=js"
export * from "./IspContent.vue?vue&type=script&setup=true&lang=js"

import "./IspContent.vue?vue&type=style&index=0&id=2cfbbb2c&scoped=true&lang=css"

import exportComponent from "../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfbbb2c"]])

export default __exports__